<script lang="typescript">
  import Panel from "../../../common/Panel.svelte";
  import type { Meeting } from "../../../common/types";
  import { createService } from "./meeting";
  import type { MeetingContext } from "./meeting";
  export let meeting: Meeting;
  const service = createService(meeting);
  const send = $service.send;
  const isProduct = meeting.product_id !== null;
  const cancel = () => send("cancel");
  const doNotCancelTheMeeting = () => send("do-not-cancel");
  const retry = () => send("cancel");
  const dontRetry = () => send("back");
  const giveReason = meeting.type.price > 0;
  let context:MeetingContext;
  $: state = $service.machine.current;
  $: context = $service.context;
  $: values = context.values;
  $: participants = meeting.passwords.length;
  $: hasPasswords = meeting.passwords.length > 0;
  $: passwordLabel = meeting.passwords.length > 1 ? "Salasanat" : "Salasana";
  $: passwords = meeting.passwords.join(", ");
  $: cancelling = state == "cancelling";
  $: isConfirm = state == 'confirm';
  $: isError = state == "error";
  $: error = context.error;
</script>

<!--
<pre>
{JSON.stringify(context, null, 2)}
</pre>
-->

<li>
  {meeting.timespan} <a href={meeting.link}>{meeting.title}</a>

  {#if meeting.is_delete_allowed}
  <span on:click={cancel} class="cancel far fa-trash-alt">
  </span>
  {/if}

  <ul>
    {#if !meeting.is_my_meeting}
      <li>Ohjaaja: {meeting.supervisor_name}</li>
    {/if}
    {#if isProduct}
      <li>Osallistujia: {participants}</li>
    {/if}
    {#if hasPasswords}
      <li>{passwordLabel}: {passwords}</li>
    {/if}
  </ul>

  {#if isConfirm}
    <div class="confirm">
      <h3>Oletko varma että haluat peruuttaa tapaamisen?</h3>
      <form on:submit|preventDefault={cancel}>
        {#if giveReason}
        <p class="cancel">
        <label for="cancel-reason">Perumisen syy ja mahdollinen ohje jatkotoimenpiteisiin</label>
        <textarea bind:value={values.reason} required rows=5 name="cancel-reason" id="cancel-reason"></textarea>
        <span class="description">Tämä teksti lähetetään asiakkaalle sähköpostitse lähetettävän kupongin mukana.</span>
        </p>
        {/if}
        <p>
        <input type=submit value="Peru tapaaminen">
        </p>
        <p>
        <button on:click={doNotCancelTheMeeting}>Älä peru tapaamista</button>
        </p>
      </form>
    </div>
  {/if}

  {#if cancelling}
    <p class="info">
      <span class="fa-lg">
        <i class="fas fa-spinner fa-spin" />
      </span>
      <span>Perutaan tapaaminen...</span>
    </p>
  {/if}
  {#if isError}
    <Panel type="error">
      <p>
        Tapaamisen peruuttaminen epäonnistui. Voit yrittää hetken kuluttua
        uudellen.
      </p>
      <div>
      {@html error}
      </div>
      <p>
      <button on:click={retry}>Yritä uudelleen</button>
      </p>
      <p>
      <button on:click={dontRetry}>Älä peruuta tapahtumaa</button>
      </p>
    </Panel>
  {/if}
</li>

<style>
  ul {
    list-style-type: circle;
  }

  li {
    margin-left: 36px;
  }

  .cancel {
    cursor: pointer;
  }

  .info {
    margin-top: 24px;
  }

  .description {
    font-size: smaller;
  }

  label {
    display: block;
  }

  .cancel span {
    display: block;
  }

  textarea {
    width: 600px;
  }
</style>
